import React from 'react'
import { useTranslation } from 'react-i18next'
import { removePrefix, TRANSPORT_DOCUMENT_TYPE_CODE_PREFIX } from 'shared/ncts/common/classifier-util'
import TransitPreviewDocumentSection from './TransitPreviewDocumentSection'
import TransitPreviewField from './TransitPreviewField'
import { TransportDocument } from '../../document/models/types'

interface TransitPreviewTransportDocumentsProps {
  transportDocuments: TransportDocument[]
}
function TransitPreviewTransportDocuments({
  transportDocuments,
}: TransitPreviewTransportDocumentsProps) {
  const { t } = useTranslation()

  if (!transportDocuments?.length) return null

  return (
    <div className="card p-2">
      <h5 className="text-secondary mb-2">
        {
          t('declaration.p5.transportDocuments')
        }
      </h5>
      {
        transportDocuments.map((document) => (
          <TransitPreviewDocumentSection
            key={document.id}
            document={document}
            documentTypePrefix={TRANSPORT_DOCUMENT_TYPE_CODE_PREFIX}
          >
            <div className="col-12">
              <TransitPreviewField
                label={t('declaration.p5.transportDocumentType')}
                value={removePrefix(document.documentType, TRANSPORT_DOCUMENT_TYPE_CODE_PREFIX) ?? ''}
              />
              <TransitPreviewField
                label={t('declaration.p5.transportDocumentReferenceNumber')}
                value={document.referenceNumber ?? ''}
              />
            </div>
          </TransitPreviewDocumentSection>
        ))

      }
    </div>

  )
}

export default TransitPreviewTransportDocuments
